import ReactGA from "react-ga4";

const isPixelAvailable = () => typeof window.fbq === "function";

// Generic Custom Event Tracker
const trackCustomEvent = (eventName, params = {}) => {
  if (isPixelAvailable()) {
    window.fbq("trackCustom", eventName, params);
    console.log(`Meta Pixel: Tracked ${eventName}`, params);
  } else {
    console.warn(
      `Meta Pixel function (fbq) not available for event: ${eventName}`
    );
  }
};

// General
export const trackContact = (reason, courseName) => {
  trackCustomEvent("Contact", {
    reason: reason,
    course_name: courseName,
    activated: 1,
  });
  ReactGA.event({
    category: 'Contact',
    action: 'Contact',
    label: courseName,

  });
};

// Ratgeber Events
export const trackRatgeberStart = (url, courseName) => {
  trackCustomEvent("RatgeberStart", {
    url: url,
    course_name: courseName,
    activated: 1,
  });
  ReactGA.event({
    action: 'RatgeberStart',
    label: courseName,

  });
};

export const trackRatgeberAbgeschlossen = (url, courseName) => {
  trackCustomEvent("RatgeberAbgeschlossen", {
    url: url,
    course_name: courseName,
    activated: 1,
  });
  ReactGA.event({
    action: 'RatgeberAbgeschlossen',
    category: 'Ratgeber',
    label: courseName,

  });
};

export const trackRelatedRatgeberClick = (url, courseName) => {
  trackCustomEvent("RelatedRatgeberClick", {
    url: url,
    course_name: courseName,
    activated: 1,
  });
  ReactGA.event({
    action: 'RelatedRatgeberClick',
    category: 'Ratgeber',
    label: courseName,

  });
};

// Bewertungs Events

export const trackBewertungStart = (url) => {
  trackCustomEvent("BewertungStart", {
    url: url,
    activated: 1,

  });

  ReactGA.event({
    action: 'BewertungStart',
    category: 'Bewertung',
    label: url,

  });
};

export const trackBewertungAbgeschlossen = (url) => {
  trackCustomEvent("BewertungAbgeschlossen", {
    url: url,
    activated: 1,

  });
  ReactGA.event({
    action: 'BewertungAbgeschlossen',
    category: 'Bewertung',
    label: url,

  });
};
// Suchprofil
export const trackSuchprofilStart = () => {
  trackCustomEvent("SuchprofilStart", {
    activated: 1,

  });
  ReactGA.event({
    action: 'SuchprofilStart',
    category: 'Suchprofil',

  });
};

export const trackSuchprofilAbgeschlossen = () => {
  trackCustomEvent("SuchprofilAbgeschlossen", {
    activated: 1,

  });
  ReactGA.event({
    action: 'SuchprofilAbgeschlossen',
    category: 'Suchprofil',

  });
};
// Beratungstermin Events
export const trackBeratungsterminStart = (url) => {
  trackCustomEvent("BeratungsterminStart", {
    url: url,
    activated: 1,

  });
  ReactGA.event({
    action: 'BeratungsterminStart',
    category: 'Beratungstermin',
    label: url,

  });
};

export const trackBeratungsterminClick = (url, reason) => {
  trackCustomEvent("BeratungsterminClick", {
    url: url,
    reason: reason,
    activated: 1,

  });
  ReactGA.event({
    action: 'BeratungsterminClick',
    category: 'Beratungstermin',
    label: url,

  })
};

export const trackBeratungsterminAbgeschlossen = (url) => {
  trackCustomEvent("BeratungsterminAbgeschlossen", {
    url: url,
    activated: 1,

  });
  ReactGA.event({
    action: 'BeratungsterminAbgeschlossen',
    category: 'Beratungstermin',
    label: url,

  });
};

// Expose Events
export const trackExposeAnfrageStart = (url, reason) => {
  trackCustomEvent("ExposeAnfrageStart", {
    url: url,
    reason: reason,
    activated: 1,

  });
  ReactGA.event({
    action: 'ExposeAnfrageStart',
    category: 'ExposeAnfrage',
    label: url,
    reason: reason,

  });
};

export const trackExposeAnfrageAbgeschlossen = (url) => {
  trackCustomEvent("ExposeAnfrageAbgeschlossen", {
    url: url,
    activated: 1,

  });
  ReactGA.event({
    action: 'ExposeAnfrageAbgeschlossen',
    category: 'ExposeAnfrage',
    label: url,

  });
};

export const trackRelatedExposeClick = (url) => {
  trackCustomEvent("RelatedExposeClick", {
    url: url,
    activated: 1,

  });
  ReactGA.event({
    action: 'RelatedExposeClick',
    category: 'ExposeAnfrage',
    label: url,

  })
};

// ... add functions for all your other custom events ...
